/*Sidebar*/

import i_vias from './../UI/icons/Sidebar/Vias.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias2.svg'
import i_beneficios from './../UI/icons/Sidebar/Puntos-interes.svg'
import i_beneficios2 from './../UI/icons/Sidebar/Puntos-interes2.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades2.svg'
import i_etapas from './../UI/icons/Sidebar/Proyecto.svg'
import i_etapas2 from './../UI/icons/Sidebar/Proyecto2.svg'
import i_ayudaventas from './../UI/icons/Sidebar/Ayudaventas2.svg'
import i_ayudaventas2 from './../UI/icons/Sidebar/Ayudaventas.svg'

import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Amenities*/
import i_porteria from './../UI/icons/Amenities/Portonovo/Porteria.svg'
import i_porteria2 from './../UI/icons/Amenities/Portonovo/Porteria White.svg'
import i_piscinaAdultos from './../UI/icons/Amenities/Portonovo/Piscina.svg'
import i_piscinaAdultos2 from './../UI/icons/Amenities/Portonovo/Piscina_White.svg'
import i_piscinaInfantil from './../UI/icons/Amenities/Portonovo/PiscinaInfantil.svg'
import i_piscinaInfantil2 from './../UI/icons/Amenities/Portonovo/PiscinaInfantil2_white.svg'
import i_juegosInfantiles from './../UI/icons/Amenities/Portonovo/Juegos infantiles.svg'
import i_juegosInfantiles2 from './../UI/icons/Amenities/Portonovo/Juegos infantiles_White.svg'
import i_banosPiscina from './../UI/icons/Amenities/Portonovo/Banospiscina.svg'
import i_banosPiscina2 from './../UI/icons/Amenities/Portonovo/Banospiscina_White.svg'
import i_cuartotecnico from './../UI/icons/Amenities/Antao/CuartoTecnico.svg'
import i_cuartoTecnico2 from './../UI/icons/Amenities/Antao/CuartoTecnico_White.svg'
import i_cuartoBasuras from './../UI/icons/Amenities/Portonovo/CuartoBasuras.svg'
import i_cuartoBasuras2 from './../UI/icons/Amenities/Portonovo/CuartoBasuras_White.svg'
import i_salon from './../UI/icons/Amenities/Portonovo/ClubHouse.svg'
import i_salon2 from './../UI/icons/Amenities/Portonovo/ClubHouse_White.svg'
import i_tren from './../UI/icons/Amenities/Portonovo/Tren.svg'
import i_tren2 from './../UI/icons/Amenities/Portonovo/Tren_White.svg'
import i_balancines from './../UI/icons/Amenities/Portonovo/Balancin.svg'
import i_balancines2 from './../UI/icons/Amenities/Portonovo/Balancin_White.svg'
import i_playa from './../UI/icons/Amenities/Portonovo/Playa.svg'
import i_playa2 from './../UI/icons/Amenities/Portonovo/Playa_White.svg'
import i_humedas from './../UI/icons/Amenities/Portonovo/Zonas humedas.svg'
import i_humedas2 from './../UI/icons/Amenities/Portonovo/Zonas humedas_white.svg'
import i_tenis from './../UI/icons/Amenities/Portonovo/Tennis.svg'
import i_tenis2 from './../UI/icons/Amenities/Portonovo/Tennis_White.svg'
import igym from './../UI/icons/Amenities/Portonovo/Gym.svg'
import igym2 from './../UI/icons/Amenities/Portonovo/Gym_white.svg'

/*POIS*/
import i_salud from './../UI/icons/POI/Salud.svg'
import i_comercio from './../UI/icons/POI/Comercio.svg'
import i_transporte from './../UI/icons/POI/Transporte.svg'
import i_otros from './../UI/icons/POI/Otros.svg'
import i_colegios from './../UI/icons/POI/Educacion.svg'
import i_parques from './../UI/icons/POI/Parques.svg'
import i_mercados from './../UI/icons/POI/Mercado.svg'
import i_seguridad from './../UI/icons/POI/Seguridad.svg'

import i_salud2 from './../UI/icons/POI/Salud2.svg'
import i_comercio2 from './../UI/icons/POI/Comercio2.svg'
import i_transporte2 from './../UI/icons/POI/Transporte2.svg'
import i_otros2 from './../UI/icons/POI/Otros2.svg'
import i_colegios2 from './../UI/icons/POI/Educacion2.svg'
import i_parques2 from './../UI/icons/POI/Parques2.svg'
import i_mercados2 from './../UI/icons/POI/Mercado2.svg'
import i_seguridad2 from './../UI/icons/POI/Seguridad2.svg'


export default {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'ayuda': i_ayudaventas,
    'ayuda2': i_ayudaventas2,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,

    /*Amenidades*/
    'Portería Principal': i_porteria,
    'Portería Principal2': i_porteria2,
    'Portería': i_porteria,
    'Portería2': i_porteria2,
    'Piscina adultos': i_piscinaAdultos,
    'Piscina adultos2': i_piscinaAdultos2,
    'Piscina adultos 2': i_piscinaAdultos,
    'Piscina adultos 22': i_piscinaAdultos2,
    'Piscina infantil': i_piscinaInfantil,
    'Piscina infantil2': i_piscinaInfantil2,
    'Piscina niños': i_piscinaInfantil,
    'Piscina niños2': i_piscinaInfantil2,
    'Piscina niños 2': i_piscinaInfantil,
    'Piscina niños 22': i_piscinaInfantil2,
    'Juegos de niños': i_juegosInfantiles,
    'Juegos de niños2': i_juegosInfantiles2,
    'Baños piscina': i_banosPiscina,
    'Baños piscina2': i_banosPiscina2,
    'Cuartos técnicos': i_cuartotecnico,
    'Cuartos técnicos2': i_cuartoTecnico2,

    'Parque infantil': i_juegosInfantiles,
    'Parque infantil2': i_juegosInfantiles2,
    'Baños de piscinas': i_banosPiscina,
    'Baños de piscinas2': i_banosPiscina2,
    'Cuarto de basuras': i_cuartoBasuras,
    'Cuarto de basuras2': i_cuartoBasuras2,
    'Salón Social - Quiosco 1': i_salon,
    'Salón Social - Quiosco 12': i_salon2,
    'Tren de madera': i_tren,
    'Tren de madera2': i_tren2,
    'Balancines': i_balancines,
    'Balancines2': i_balancines2,
    'Playa': i_playa,
    'Playa2': i_playa2,
    'Sauna y Turco': i_humedas,
    'Sauna y Turco2': i_humedas2,
    'Gimnasio': igym,
    'Gimnasio2': igym2,
    'Cancha de tenis': i_tenis,
    'Cancha de tenis2': i_tenis2,

    /**/
    "Salud": i_salud,
    "Salud2": i_salud2,
    "Seguridad": i_seguridad,
    "Seguridad2": i_seguridad2,
    "Comercio": i_comercio,
    "Comercio2": i_comercio2,
    "Transporte": i_transporte,
    "Transporte2": i_transporte2,
    "Otros": i_otros,
    "Otros2": i_otros2,
    "Educación": i_colegios,
    "Educación2": i_colegios2,
    "Supermercados": i_mercados,
    "Supermercados2": i_mercados2,
    "Parques": i_parques,
    "Parques2": i_parques2,
}